import { useTranslate } from "ra-core";
import { Link } from "react-router";

import { Isotipo } from "../tema/Isotipo";

/** Isotipo + nombre de la app, enlazados al inicio. Cambia al isotipo blanco en modo oscuro. */
export const MarcaCabecera = () => {
  const translate = useTranslate();
  return (
    <Link
      to="/"
      className="flex items-center gap-2.5 no-underline text-foreground"
    >
      <Isotipo className="h-7" />
      <span className="font-marca uppercase tracking-[0.12em] text-base font-medium leading-none">
        {translate("nevora.app.nombre")}
      </span>
    </Link>
  );
};
